import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface ThemeContextType {
    isDarkMode: boolean;
    toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isDarkMode, setIsDarkMode] = useState(() => {
        // Leer tema desde localStorage
        const savedTheme = localStorage.getItem('compilatime-theme');
        if (savedTheme) {
            return savedTheme === 'dark';
        }
        // Por defecto, usar modo claro
        return false;
    });

    useEffect(() => {
        // Aplicar clase dark al elemento html
        if (isDarkMode) {
            document.documentElement.classList.add('dark');
            localStorage.setItem('compilatime-theme', 'dark');
        } else {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('compilatime-theme', 'light');
        }
    }, [isDarkMode]);

    const toggleTheme = () => {
        setIsDarkMode(prev => !prev);
    };

    return (
        <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within ThemeProvider');
    }
    return context;
};